import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import {withRouter} from 'react-router-dom';
import axios from 'axios';
import {API_ROOT} from '../../../../../../utils';
import GmailAddonPopupShareLabel from './gmail-add-on-share-label';
import {contactDetailsEditMode} from '../../../../../../../actions/contactActions';
import {getSelectedContactsGroup} from '../../../../../../../actions/contactsGroupItemActions';
import {getSharingDetailsPopup} from '../../../../../../../actions/sharingDetailsActions';
import {setGmailAddOnData, getProfile} from '../../../../../../../actions/profileActions';
import {findSystemGroups} from '../../../../../../../actions/systemGroupActions';
import GmailAddOnSharingDetails from '../../../gmail-add-on-sharing'
import GmailAddonPopupShareIndividualContact from './gmail-add-on-share-individual-contact';
import Loader from '../../../../../../components/sprite/components/loader';

class GmailAddonPopup extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			gmailAddOnShareIndividualContact: false,
			gmailAddOnShareLabel: false,
		};
	}

	componentDidMount() {
		this.props.getProfile(true);
		this.props.findSystemGroups();
	}

	verifyUser = (userId) => {

		let queryParameter = queryString.parse(this.props.location.search);
		if (queryParameter.userId !== userId) {
			// localStorage.setItem("urlFromGmailAddOn",window.location.href)
			let request = `${API_ROOT}/account/logout/`;
			axios.get(request, {withCredentials: true}).then(response => {
				let urlForBackend = window.location.href;
				let login_hint = queryParameter.userEmail;
				window.location.href = urlForBackend + `&login_hint=` + login_hint;
			})
		} else {

			/**
			 * stop the loading
			 */
			this.useQuery();
		}
	};


	componentDidUpdate(prevProps, prevState) {
		if (this.props.profile !== prevProps.profile) {
			if (this.props.profile && this.props.profile.id) {
				this.verifyUser(this.props.profile.id)
			}
		}
	}

	/**
	 * Check the path of the url and navigate accordingly
	 */
	useQuery = () => {
		let queryParameter = queryString.parse(this.props.location.search);
		this.props.setGmailAddOnData(queryParameter);
		let contactId = this.props.location.pathname.split('/');

		if (
			this.props.location.pathname === '/popup/label/' &&
			queryParameter.action === 'new'
		) {
			queryParameter.checkGmailAddon = 'gmailaddon';
			this.props.setGmailAddOnData(queryParameter);
			this.props.getSharingDetailsPopup([true, 'gmail_add_on_new_label']);
		} else if (
			this.props.location.pathname === '/popup/label/' &&
			queryParameter.action === 'edit'
		) {
			this.props.getSharingDetailsPopup([true, 'gmail_add_on_rename_label']);
		} else if (
			queryParameter.action === 'share' &&
			contactId[1] === 'popup' &&
			contactId[2] === 'label'
		) {
			queryParameter.checkGmailAddon = 'gmailaddon';
			//Gets the Gmail Add on data from url and setting in the store
			this.props.setGmailAddOnData(queryParameter);
			this.setState({gmailAddOnShareLabel: true});
		} else if (contactId[1] === 'popup' && contactId[2] === 'contact' && (queryParameter.action === 'add' || queryParameter.action === 'share' || queryParameter.action === 'view')) {
			queryParameter.checkGmailAddon = 'gmailaddon';
			this.props.setGmailAddOnData(queryParameter);
			this.setState({gmailAddOnShareIndividualContact: true});
		} else if (contactId[1] === 'popup' && contactId[2] === 'contact' && queryParameter.action === 'edit') {
			queryParameter.checkGmailAddon = 'gmailaddon';
			this.props.setGmailAddOnData(queryParameter);
			this.props.setContactDetailsEditMode(true);
			this.props.getSharingDetailsPopup([true, 'gmail_contact_details', [{id: contactId[3], type: 'contact'}]])
		} else if (contactId[1] === 'popup' && contactId[2] === 'contact' && (queryParameter.action === 'addNotes' || queryParameter.action === 'viewNotes')) {
			queryParameter.checkGmailAddon = 'gmailaddon';
			this.props.setGmailAddOnData(queryParameter);
			this.setState({gmailAddOnShareIndividualContact: true});
		} else if (contactId[1] === 'popup' && contactId[2] === 'contact' && queryParameter.action === 'new') {
			queryParameter.checkGmailAddon = 'gmailaddon';
			this.props.getSelectedContactsGroup(queryParameter.labelId);
			this.props.setGmailAddOnData(queryParameter);
			this.props.getSharingDetailsPopup([true, 'gmail_new_contact'])
		} else if (contactId[1] === 'popup' && contactId[2] === 'contact' &&  queryParameter.action === 'createNewContact') {
			queryParameter.checkGmailAddon = 'gmailaddon';
			this.props.setGmailAddOnData(queryParameter);
			this.props.getSharingDetailsPopup([true, 'gmail_new_contact'])
		}
	};

	/**
	 * check the url and navigate to the component accordingly
	 */

	render() {
		if(this.props.selectedContactsGroup !== null){
			if (this.state.gmailAddOnShareIndividualContact) {
				return <GmailAddonPopupShareIndividualContact/>;
			} else if (this.state.gmailAddOnShareLabel) {
				return <GmailAddonPopupShareLabel/>;
			} else {
				return <GmailAddOnSharingDetails/>;
			}
		} else {
			return <Loader/>
		}

	}
}

const mapStateToProps = (state) => ({
	profile: state.profileReducer.getProfile,
	selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup
});

const mapDispatchToProps = (dispatch) => ({
	getSharingDetailsPopup: (array) => {
		dispatch(getSharingDetailsPopup(array));
	},
	findSystemGroups : () => {
		dispatch(findSystemGroups())
	},
	setGmailAddOnData: (object) => {
		dispatch(setGmailAddOnData(object));
	},
	setContactDetailsEditMode: (boolean) => {
		dispatch(contactDetailsEditMode(boolean))
	},
	getSelectedContactsGroup: (object) => {
		dispatch(getSelectedContactsGroup(object));
	},
	getProfile: (boolean) => dispatch(getProfile(boolean))
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(GmailAddonPopup)
);
